export type whereClause = [field: string, operator: keyof typeof queryOperators, value: unknown];

type Head<T extends string> = T extends `${infer First}.${string}` ? First : T;
type Tail<T extends string> = T extends `${string}.${infer Rest}` ? Rest : never;

export type DeepPick<T, K extends string> = T extends object
  ? {
      [P in Head<K> & keyof T]: Tail<Extract<K, `${P}.${string}`>> extends never
        ? T[P]
        : T[P] extends readonly unknown[]
          ? DeepPick<T[P][number], Tail<Extract<K, `${P}.${string}`>>>[]
          : DeepPick<T[P], Tail<Extract<K, `${P}.${string}`>>>;
    }
  : T;

export type FirebaseResponseItem<TData> = {
  id: string;
  fields: TData;
  sys: {
    referencedBy: string[];
  };
};

export const queryOperators = {
  eq: '==',
  ne: '!=',
  lt: '<',
  lte: '<=',
  gt: '>',
  ge: '>=',
  in: 'in',
  notIn: 'not-in',
  contains: 'array-contains',
  containsany: 'array-contains-any',
};

export const createWhereQuery = (where: whereClause[]) => {
  const query: { [key: string]: string } = {};
  where?.forEach((item) => {
    const key = `${item[0]}$${item[1]}`;
    const value = JSON.stringify(item[2]);
    query[key] = value;
  });

  return query;
};
